import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

interface MarkdownRendererProps {
  content: string;
}

export default function MarkdownRenderer({ content }: MarkdownRendererProps) {
  return (
    <article
      className="
        markdown-body
        leading-relaxed
        text-[15px]
        md:text-[16px]
        text-foreground
        tracking-tight
        [&_h1]:font-display [&_h2]:font-display [&_h3]:font-display
        [&_h1]:font-bold [&_h2]:font-bold [&_h3]:font-bold
        [&_h1]:tracking-[-0.02em] [&_h2]:tracking-[-0.02em] [&_h3]:tracking-[-0.02em]
        prose-headings:mt-8
        prose-headings:mb-3
      "
    >
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
    </article>
  );
}
